export const pricingFaqData = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 14 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 14-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 Glucose Tracking measures your glucose levels
        through the interstitial fluid. There is generally no bleeding while
        removing the sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },

  // Plan FAQ
  {
    title:
      'Do I get access to the Ultrahuman Premium subscription along with my Ultrahuman M1 Glucose Tracking subscription?',
    description: (
      <>
        Yes. Your Ultrahuman M1 Glucose Tracking subscription comes bundled with
        the Ultrahuman Premium subscription—which gives you access to 1000+
        hours of fitness and recovery masterclasses.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M1 Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li>
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <span className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </span>
      </>
    ),
  },
  {
    title: 'What is ‘Delivery on Demand?’',
    description: (
      <>
        By default, we ship the CGMs in the following batches:
        <br />
        <br />
        <b>12 Weeks</b>
        <br />
        6 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>24 Weeks</b>
        <br />
        12 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>52 Weeks</b>
        <br />
        Batch 1: 6 CGMs shipped together at the time of purchase
        <br />
        Batch 2: 10 CGMs shipped together on the 3rd month
        <br />
        Batch 3: 10 CGMs shipped together on the 5th month
        <br />
        <br />
        However, if you prefer a different cadence, we’re happy to arrange it
        for you.
      </>
    ),
  },

  // Subscription
  {
    title: 'How can I make changes to my subscription plan?',
    description: (
      <>
        It’s easy. If you’re looking to skip/delay, or pause your subscription,
        use{' '}
        <a
          href="https://form.typeform.com/to/vaBQVV9q"
          target="_blank"
          rel="noreferrer"
        >
          this link
        </a>{' '}
        to manage it. If you’re looking to cancel your subscription, please
        reach out to{' '}
        <a href="mailto:cyborg@ultrahuman.com" target="_blank" rel="noreferrer">
          cyborg@ultrahuman.com
        </a>
        .
      </>
    ),
  },
  {
    title: 'If I subscribe, when will I get my next order?',
    description: (
      <>
        Your order will be processed as soon as we receive a payment
        confirmation from your account. Since this is a monthly subscription, we
        should be able to ship you the order every 30 days. Delivery timelines
        are usually anywhere between 2-5 days.
      </>
    ),
  },

  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In India, the M1 Lite subscription supports the Libre 1 sensor with the
        app.
      </>
    ),
  },
];

export const newPricingFaqData = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 14 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 14-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 Glucose Tracking measures your glucose levels
        through the interstitial fluid. There is generally no bleeding while
        removing the sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },
  // Plan FAQ
  {
    title:
      'Do I get access to the Ultrahuman Premium subscription along with my Ultrahuman M1 Glucose Tracking subscription?',
    description: (
      <>
        Yes. Your Ultrahuman M1 Glucose Tracking subscription comes bundled with
        the Ultrahuman Premium subscription—which gives you access to 1000+
        hours of fitness and recovery masterclasses.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M1 Glucose Tracking plan include?',
    description: (
      <>
        {/* <p></p> */}
        <br />
        <ul>
          <li key="1">CGM sensors (units as per the plan chosen).</li>
          <li key="2">
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li key="3">Sanitising wipes.</li>
          <li key="4">
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li key="5">
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li key="6">
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </p>
      </>
    ),
  },  {
    title: 'What is ‘Delivery on Demand?’',
    description: (
      <>
        By default, we ship the CGMs in the following batches:
        <br />
        <br />
        <b>12 Weeks</b>
        <br />
        6 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>24 Weeks</b>
        <br />
        12 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>52 Weeks</b>
        <br />
        Batch 1: 6 CGMs shipped together at the time of purchase
        <br />
        Batch 2: 10 CGMs shipped together on the 3rd month
        <br />
        Batch 3: 10 CGMs shipped together on the 5th month
        <br />
        <br />
        However, if you prefer a different cadence, we’re happy to arrange it
        for you.
      </>
    ),
  },

  // Subscription
  {
    title: 'How can I make changes to my subscription plan?',
    description: (
      <>
        It’s easy. If you’re looking to skip/delay, or pause your subscription,
        use{' '}
        <a
          href="https://form.typeform.com/to/vaBQVV9q"
          target="_blank"
          rel="noreferrer"
        >
          this link
        </a>{' '}
        to manage it. If you’re looking to cancel your subscription, please
        reach out to{' '}
        <a href="mailto:cyborg@ultrahuman.com" target="_blank" rel="noreferrer">
          cyborg@ultrahuman.com
        </a>
        .
      </>
    ),
  },
  {
    title: 'If I subscribe, when will I get my next order?',
    description: (
      <>
        Your order will be processed as soon as we receive a payment
        confirmation from your account. Since this is a monthly subscription, we
        should be able to ship you the order every 30 days. Delivery timelines
        are usually anywhere between 2-5 days.
      </>
    ),
  },
];

export const pricingFaqData_noSubs = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 14 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 14-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M1 Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li>
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </p>
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.{' '}
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.{' '}
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 Glucose Tracking measures your glucose levels
        through the interstitial fluid. There is generally no bleeding while
        removing the sensor.
      </>
    ),
  },
  {
    title: 'What is ‘Delivery on Demand?’',
    description: (
      <>
        By default, we ship the CGMs in the following batches:
        <br />
        <br />
        <b>12 Weeks</b>
        <br />
        6 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>24 Weeks</b>
        <br />
        12 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>52 Weeks</b>
        <br />
        Batch 1: 6 CGMs shipped together at the time of purchase
        <br />
        Batch 2: 10 CGMs shipped together on the 3rd month
        <br />
        Batch 3: 10 CGMs shipped together on the 5th month
        <br />
        <br />
        However, if you prefer a different cadence, we’re happy to arrange it
        for you.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },
];

export const pricingFaqData_ae = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 15-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 15-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 Live Glucose Tracking measures your glucose levels
        through the interstitial fluid. There is generally no bleeding while
        removing the sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },
  // Plan FAQ
  {
    title:
      'Do I get access to the Ultrahuman Premium subscription along with my M1 Live Glucose Tracking Recurring Subscription?',
    description: (
      <>
        Yes. Your Ultrahuman M1 Live Glucose Tracking Recurring Subscription
        comes bundled with the Ultrahuman Premium subscription—which gives you
        access to 1000+ hours of fitness and recovery masterclasses.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M1 Live Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 Live plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </p>
      </>
    ),
  },
  {
    title: 'Do I receive all my sensors at once?',
    description: (
      <>
        By default, we ship the CGMs in the following batches:
        <br />
        <br />
        <b>1 Month Plan</b>
        <br />
        2 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>3 Month Plan</b>
        <br />
        6 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>6 Month Plan</b>
        <br />
        Batch 1: 8 CGMs shipped together at the time of purchase.
        <br />
        Batch 2: 5 CGMs shipped together on the 4th month.
        <br />
        <br />
        <b>1 Year Plan</b>
        <br />
        Batch 1: 8 CGMs shipped together at the time of purchase
        <br />
        Batch 2: 6 CGMs shipped on the 3rd month.
        <br />
        Batch 3: 6 CGMs shipped on the 6th month.
        <br />
        Batch 3: 6 CGMs shipped on the 9th month.
        <br />
        <br />
        However, if you prefer a different cadence, we’re happy to arrange it
        for you.
      </>
    ),
  },

  // Subscription
  {
    title: 'How can I make changes to my recurring subscription plan?',
    description: (
      <>
        It’s easy. If you’re looking to skip/delay, or pause your subscription,
        use{' '}
        <a
          href="https://form.typeform.com/to/vaBQVV9q"
          target="_blank"
          rel="noreferrer"
        >
          this link
        </a>{' '}
        to manage it. If you’re looking to cancel your subscription, please
        reach out to{' '}
        <a href="mailto:cyborg@ultrahuman.com">cyborg@ultrahuman.com</a>.
      </>
    ),
  },
  {
    title: 'What’s your refund policy?',
    description: (
      <>
        We issue refunds in two cases:
        <br />
        <br />
        1. You faced an allergic reaction to the sensor.
        <br />
        2.You received more than two faulty sensors consecutively and want to
        opt for a refund instead of a sensor replacement.
        <br />
        <br />
        All refunds will be processed within 48 working hours. For more
        questions, you can reach out to our support or write to{' '}
        <a href="mailto:cyborg@ultrahuman.com">cyborg@ultrahuman.com</a>.
      </>
    ),
  },
  {
    title: 'I think my sensor may be faulty. What should I do?',
    description: (
      <>
        If you suspect your sensor may be faulty, you can report this to our
        support team, who can check if it is indeed the case. Sometimes, sensors
        may face calibration issues which can be fixed easily without replacing
        the sensor.
        <br />
        <br />
        Once our support team confirms that the sensor is faulty, please do not
        throw away the faulty sensor. We’ll issue a replacement immediately and
        arrange a return pick-up for your faulty sensor.
      </>
    ),
  },
  {
    title: 'When will I receive my next order?',
    description: (
      <>
        Your order will be processed as soon as we receive a payment
        confirmation from your account. Since this is a monthly recurring
        subscription, we should be able to ship you the order every 30 days.
        Delivery timelines are usually anywhere between 1-2 days.
      </>
    ),
  },

  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In the Middle East, the M1 Lite subscription supports the Libre 2 Plus
        sensor with the app.
      </>
    ),
  },
];

export const pricingFaqData_intl = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 14 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 14-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 measures your glucose levels through the
        interstitial fluid. There is generally no bleeding while removing the
        sensor.
      </>
    ),
  },

  {
    title: 'What does my Ultrahuman M1 Live Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 Live plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li>
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </p>
      </>
    ),
  },

  {
    title: 'What’s your refund policy?',
    description: (
      <>
        We issue refunds in two cases:
        <br />
        <br />
        1. You faced an allergic reaction to the sensor.
        <br />
        2.You received more than two faulty sensors consecutively and want to
        opt for a refund instead of a sensor replacement.
        <br />
        <br />
        All refunds will be processed within 48 working hours. For more
        questions, you can reach out to our support or write to{' '}
        <a href="mailto:cyborg@ultrahuman.com">cyborg@ultrahuman.com</a>.
      </>
    ),
  },
  {
    title: 'I think my sensor may be faulty. What should I do?',
    description: (
      <>
        If you suspect your sensor may be faulty, you can report this to our
        support team, who can check if it is indeed the case. Sometimes, sensors
        may face calibration issues which can be fixed easily without replacing
        the sensor.
        <br />
        <br />
        Once our support team confirms that the sensor is faulty, please do not
        throw away the faulty sensor. We’ll issue a replacement immediately and
        arrange a return pick-up for your faulty sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },

  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In Europe and the United Kingdom, the M1 Lite subscription supports the
        Libre 2 sensor with the app.
      </>
    ),
  },
];

export const pricingFaqData_gb_eu = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes! It is essential that your phone is NFC enabled. If not, you will
        not be able to pair the Continuous Glucose Monitor (CGM sensor) with
        your phone.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 15 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 15-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M1 measures your glucose levels through the
        interstitial fluid. There is generally no bleeding while removing the
        sensor.
      </>
    ),
  },

  {
    title: 'What does my Ultrahuman M1 Live Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 Live plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li>
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          Abbott FreeStyle Libre, in their original packaging.
        </p>
      </>
    ),
  },

  {
    title: 'What’s your refund policy?',
    description: (
      <>
        We issue refunds in two cases:
        <br />
        <br />
        1. You faced an allergic reaction to the sensor.
        <br />
        2.You received more than two faulty sensors consecutively and want to
        opt for a refund instead of a sensor replacement.
        <br />
        <br />
        All refunds will be processed within 48 working hours. For more
        questions, you can reach out to our support or write to{' '}
        <a href="mailto:cyborg@ultrahuman.com">cyborg@ultrahuman.com</a>.
      </>
    ),
  },
  {
    title: 'I think my sensor may be faulty. What should I do?',
    description: (
      <>
        If you suspect your sensor may be faulty, you can report this to our
        support team, who can check if it is indeed the case. Sometimes, sensors
        may face calibration issues which can be fixed easily without replacing
        the sensor.
        <br />
        <br />
        Once our support team confirms that the sensor is faulty, please do not
        throw away the faulty sensor. We’ll issue a replacement immediately and
        arrange a return pick-up for your faulty sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },

  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In Europe and the United Kingdom, the M1 Lite subscription supports the
        Libre 2 sensor with the app.
      </>
    ),
  },
];

export const pricingFaqData_us = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Yes, you need an NFC enabled device to activate the Lingo Biosensor. However, the sensor itself utilizes Bluetooth Low Energy (BLE) technology to stream glucose readings. The transmitter communicates real-time data continuously with your smartphone via Bluetooth, and has a range of 33 feet.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 14 days. And no, they’re not reusable. Each sensor
        can be used only once, for a 14-day stint, after which you may replace
        it with a fresh one.
      </>
    ),
  },
  {
    title: 'Is there a needle in the sensor? Does a needle stay in my skin?',
    description: (
      <>
        Yes, and no. The Continuous Glucose Monitor (CGM sensor) comes with a
        hollow needle that is used to make a tiny incision in your skin (it
        doesn’t hurt more than an ant bite!), after which a thread-like filament
        is safely placed and remains under your skin for the period you have the
        sensor on.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        Not more than an ant bite. It&apos;s normal to feel some sensation
        during the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        Nope! Once applied, the sensor should not be taken off for the 14-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1 meter (3 feet). So you can shower, swim,
        and surf while wearing your sensor.
      </>
    ),
  },
  {
    title: 'Can the sensor hold up against all skin types?',
    description: (
      <>
        Yes, the sensor is compatible with all skin types. The patch used to
        cover the sensor is water/sweat resistant. So, the sensor stays intact.
        Therefore it is recommended to have a patch on at all times.
      </>
    ),
  },
  {
    title: 'Once the sensor is removed, does it bleed? ',
    description: (
      <>
        No. The Ultrahuman M2 Live measures your glucose levels through the
        interstitial fluid. There is generally no bleeding while removing the
        sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. In the US, we integrate with Abbott&apos;s
        Libre 3 Plus and Lingo Biosensors.
      </>
    ),
  },
  // Plan FAQ
  {
    title:
      'Do I get access to the Ultrahuman Premium subscription along with my M2 Live Recurring Subscription?',
    description: (
      <>
        Yes. Your Ultrahuman M2 Live Recurring Subscription comes bundled with
        the Ultrahuman Premium subscription—which gives you access to 1000+
        hours of fitness and recovery masterclasses.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M2 Live plan include?',
    description: (
      <>
        <p>Your Ultrahuman M2 Live plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to Ultrahuman digital description. That&apos;s 1000+ hours of
            fitness and recovery masterclasses.
          </li>
          <li>
            Access to Cyborg Army, an Ultrahuman community of 5000+ active
            members.
          </li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <p className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors, namely Abbott Lingo™, in their original packaging.
        </p>
      </>
    ),
  },
  {
    title: 'Sensor shipment schedule for one year plan',
    description: (
      <>
        The one-year plan will send out four shipments: two with six sensors
        each, and two with seven sensors each. Shipments are every 10 weeks,
        right before you need more, ensuring you get them on time without the
        hassle of storing a significant quantity in clean and dry conditions.
      </>
    ),
  },

  // Subscription
  {
    title: 'How can I make changes to my recurring subscription plan?',
    description: (
      <>
        Reach out to{' '}
        <a href="mailto:support@ultrahuman.com">support@ultrahuman.com</a> with
        your order number to make changes to your subscription.
      </>
    ),
  },
  {
    title: 'What’s your refund policy?',
    description: (
      <>
        We issue refunds in two cases:
        <br />
        <br />
        1. You faced an allergic reaction to the sensor.
        <br />
        2. You received more than two faulty sensors consecutively and want to
        opt for a refund instead of a sensor replacement.
        <br />
        <br />
        All refunds will be processed within 48 working hours. For more
        questions, you can reach out to our support or write to{' '}
        <a href="mailto:support@ultrahuman.com">support@ultrahuman.com</a>.
      </>
    ),
  },
  {
    title: 'I think my sensor may be faulty. What should I do?',
    description: (
      <>
        If you suspect your sensor may be faulty, you can report this to our
        support team, who can check if it is indeed the case. Sometimes, sensors
        may face calibration issues which can be fixed easily without replacing
        the sensor.
        <br />
        <br />
        Once our support team confirms that the sensor is faulty, please do not
        throw away the faulty sensor. We’ll issue a replacement immediately and
        arrange a return pick-up for your faulty sensor.
      </>
    ),
  },
  {
    title: 'If I subscribe, when will I get my next order?',
    description: (
      <>
        Since Lingo Biosensor is available over-the-counter, no prescription is required.
        Once your order is placed, it ships within 3–5 business days. For
        monthly subscriptions, you&apos;ll receive your next shipment every 30
        days.
      </>
    ),
  },

  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In the United States, the M1 Lite subscription supports the Libre 3 Plus and Abbott Lingo™ on the Ultrahuman app.
      </>
    ),
  },
];

export const pricingFaqData_in = [
  // Device FAQ
  {
    title: 'Does my device need to be NFC-enabled to pair the CGM sensor?',
    description: (
      <>
        Not anymore! The new glucose sensor connects seamlessly via Bluetooth —
        no NFC required.
      </>
    ),
  },
  {
    title: 'How long does the sensor last? Is it reusable?',
    description: (
      <>
        Each sensor lasts for 15 days. And no, they&apos;re not reusable. Each
        sensor can be used only once, for a 15-day stint, after which you may
        replace it with a fresh one.
      </>
    ),
  },
  {
    title: 'Does it hurt while putting on the sensor?',
    description: (
      <>
        It is quick and painless. It&apos;s normal to feel some sensation during
        the first day or so, as you are getting used to the sensor.
        <br />
        If you feel pain or discomfort, contact the Ultrahuman team through our
        in-app chat service. We can help you decide if you need to remove the
        sensor altogether and re-apply a fresh one.
      </>
    ),
  },
  {
    title: 'Can I take the sensor off every night?',
    description: (
      <>
        No. Once applied, the sensor should not be taken off for the 15-day
        period unless you experience any pain or discomfort.
      </>
    ),
  },
  {
    title: 'Can I wear my sensor while bathing, swimming, or surfing?',
    description: (
      <>
        Yes, yes and yes! Your glucose sensor is water-resistant for up to 30
        minutes and in depths up to 1.5 meters (5 feet). So you can shower,
        swim, and surf while wearing your sensor.
      </>
    ),
  },
  {
    title:
      'Does Ultrahuman manufacture its own CGMs or use a third-party sensor?',
    description: (
      <>
        We use third-party CGMs. Currently, we integrate with Abbott&apos;s
        FreeStyle Libre sensors—Libre 1, Libre 2, Libre 2 Plus, and Libre 3,
        Libre 3 Plus—depending on regional availability.
      </>
    ),
  },
  {
    title: 'What does my Ultrahuman M1 Live Glucose Tracking plan include?',
    description: (
      <>
        <p>Your Ultrahuman M1 Live plan should include:</p>
        <br />
        <ul>
          <li>CGM sensors (units as per the plan chosen).</li>
          <li>
            Three Ultrahuman hypoallergenic protective patches per CGM sensor.
          </li>
          <li>Sanitising wipes.</li>
          <li>
            Access to live and certified Performance Coaches who can guide you
            along your metabolic fitness journey to help you make the best use
            of the platform. (Please note that no prescriptive meal/workout
            plans will be provided).
          </li>
        </ul>
        <span className="notes">
          <br />
          Note: We use versions of third-party manufactured CGM sensors such as
          GlucoRx&apos;s Vixxa™ 2, in their original packaging.
        </span>
      </>
    ),
  },
  {
    title: 'What is ‘Delivery on Demand?’',
    description: (
      <>
        By default, we ship the CGMs in the following batches:
        <br />
        <br />
        <b>2 Weeks</b>
        <br />
        1 CGM shipped at the time of purchase.
        <br />
        <br />
        <b>4 Weeks</b>
        <br />
        2 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>12 Weeks</b>
        <br />
        6 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>24 Weeks</b>
        <br />
        12 CGMs shipped together at the time of purchase.
        <br />
        <br />
        <b>52 Weeks</b>
        <br />
        Batch 1: 6 CGMs shipped together at the time of purchase
        <br />
        Batch 2: 10 CGMs shipped together on the 3rd month
        <br />
        Batch 3: 10 CGMs shipped together on the 5th month
        <br />
        <br />
        However, if you prefer a different cadence, we&apos;re happy to arrange
        it for you.
      </>
    ),
  },
  {
    title:
      'If I have an M1 Lite subscription, which sensor is compatible with the Ultrahuman app?',
    description: (
      <>
        In India, the M1 Lite subscription supports the Vixxa™ 2 sensors with
        the app.
      </>
    ),
  },
];
